import { APPLICATION_ROUTES, MODULE_ROUTES, Route } from '@philips-emr/hpms-stipulator-commons';
import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

export default function registerGestaoContrato(): void {

  const modules = [
    {
      entry: 'alteracao-beneficiario',
      id: 'alteracao-beneficiario',
      name: '$expression.$1036838',
      route: APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO,
      closeable: true,
    }, {
      entry: 'exclusao-beneficiario',
      id: 'exclusao-beneficiario',
      name: 'beneficiario.exclusao',
      route: APPLICATION_ROUTES.EXCLUSAO_BENEFICIARIO,
      closeable: true,
    }, {
      entry: 'inclusao-beneficiario',
      id: 'inclusao-beneficiario',
      name: 'beneficiario.inclusao',
      route: MODULE_ROUTES.BENEFICIARIOS,
      closeable: true,
      routes: [
        {
          name: 'inclusao-beneficiario-main',
          route: APPLICATION_ROUTES.INCLUSAO_BENEFICIARIO,
          main: true,
          closeable: true,
          children: [
            {
              name: 'stipulator.nova-inclusao',
              route: Route.BENEF_NOVA,
              closeable: true,
            },
            {
              name: 'stipulator.reenviar-inclusao',
              route: Route.BENEF_SEQ_REENVIAR,
              closeable: true,
            },
            {
              name: 'stipulator.detalhes',
              route: Route.BENEF_SEQ_DETALHES,
              closeable: true,
            },
          ],
        },
      ],
    }, {
      entry: 'movimentacao-lote',
      id: 'movimentacao-lote',
      name: 'movimentacao.lote',
      route: APPLICATION_ROUTES.MOVIMENTACAO_LOTE,
      closeable: true,
    }, {
      entry: 'reinclusao-beneficiario',
      id: 'reinclusao-beneficiario',
      name: 'stipulator.reinclusao-beneficiario',
      route: APPLICATION_ROUTES.REINCLUSAO_BENEFICIARIO,
      closeable: true,
    },
  ];

  applicationModuleRegistry.registerGroup({
    entry: 'gestao-contrato',
    id: 'gestao-contrato',
    name: '$expression.$1042754',
    modules,
    order: 3,
    closeable: true,
  });
}
